import { HOST } from "api/apiClient";
import ReactMarkdown from "react-markdown";
import React from "react";
import Box from "ReusableComponents/Box";
import Text from "ReusableComponents/Text";
import { COLORS, SIZES, WEIGHT } from "theme";

const ContactSection = ({ title, img, description, small, alt }) => {
  return (
    <Box>
      <Box position="relative" h="589px">
        <Box
          display="flex"
          flexDirection="column"
          position="absolute"
          bottom="0"
          left="0"
          h="-webkit-fill-available"
          w="-webkit-fill-available"
          background="linear-gradient(to right, rgba(0,0,0,0.65) 0%,rgba(0,0,0,0) 100%)"
          justifyContent="flex-end"
        ></Box>
        <img
          src={small ? img : HOST + img}
          alt={alt}
          style={{ height: "inherit", width: "100%", objectFit: "cover" }}
        />
      </Box>
      <Box
        padding={small ? "28px" : "28px 80px"}
        background={COLORS.lightBlack}
      >
        <Box>
          <Text
            fontSize={small ? SIZES.twentyFour : SIZES.forty}
            textColor="white"
            fontWeight="bold"
            margin="0"
          >
            {title}
          </Text>
        </Box>
        <Text
          textColor={COLORS.white}
          lineHeight="1.5"
          fontWeight={WEIGHT.regular}
          fontSize={small ? SIZES.fourteen : SIZES.twenty}
          margin="0"
        >
          <ReactMarkdown children={description} />
        </Text>
      </Box>
    </Box>
  );
};

export default ContactSection;
